import React from "react";
import { Button as AntButton } from "antd";
import PropTypes from "prop-types";

// CSS
import "./Button.css";

const Button = (props) => {
  Button.propTypes = {
    children: PropTypes.node,
    onClick: PropTypes.func.isRequired,
    type: PropTypes.bool,
    disabled: PropTypes.bool,
    className: PropTypes.string,
  };

  return (
    <AntButton
      block={props.type ? props.type : null}
      onClick={props.onClick}
      disabled={props.disabled ? props.disabled : false}
      className={
        props.className
          ? `helbest-no-btn-border ${props.className}`
          : "helbest-no-btn-border"
      }
      type="link">
      {props.children}
    </AntButton>
  );
};

export default Button;
